import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar, FiArrowUpRight } from "react-icons/fi";

export default function MissingPunchesCard() {
  const [filter, setFilter] = useState("Today");

  const data = {
    Today: { count: "09", percent: "+18.5%", status: "Critical" },
    Weekly: { count: "21", percent: "+12.2%", status: "Warning" },
    Monthly: { count: "45", percent: "+25.1%", status: "Critical" },
  };

  const current = data[filter];

  return (
    <Card className="mp-card h-100">
      <Card.Body className="mp-body">

        {/* BACKGROUND IMAGE */}
        <div className="mp-bg"></div>

        {/* HEADER */}
        <div className="mp-header">
          <h5>Missing Punches</h5>

          <Dropdown align="end">
            <Dropdown.Toggle className="mp-dropdown">
              <FiCalendar size={14} /> {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {["Today", "Weekly", "Monthly"].map((item) => (
                <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* SUB TEXT */}
        <p className="mp-sub">Total Number of Missing Punches</p>

        {/* COUNT + BADGE */}
        <div className="mp-count-row">
          <h3>{current.count}</h3>
          <span className="mp-badge">{current.status}</span>
        </div>

        {/* FOOTER */}
        <div className="mp-footer">

          {/* AVATARS */}
          <div className="mp-avatars">
            {[
              "avatar-02-1.jpg",
              "avatar-03.jpg",
              "avatar-05.jpg",
              "avatar-06-1.jpg",
              "avatar-07-1.jpg",
            ].map((img, i) => (
              <img
                key={i}
                src={`/assets/img/profiles/${img}`}
                alt=""
                className="mp-avatar"
              />
            ))}
            <div className="mp-avatar more">+6</div>
          </div>

          {/* PERCENT */}
          <div className="mp-percent">
            {current.percent}
            <span className="mp-arrow">
              <FiArrowUpRight size={14} />
            </span>
          </div>
        </div>

      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`

/* CARD */
.mp-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  position: relative;
  background: #fff;
}

/* BODY */
.mp-body {
  position: relative;
  padding: 20px;
  z-index: 1;
}

/* BACKGROUND IMAGE */
.mp-bg {
  position: absolute;
  inset: 0;
  background-image: url(${process.env.PUBLIC_URL + "/assets/img/bg/attendance-bg-1.png"});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: cover;
  opacity: 0.08;
  z-index: 0;
}

/* HEADER */
.mp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  position: relative;
  z-index: 2;
}

.mp-header h5 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

/* DROPDOWN */
.mp-dropdown,
.mp-dropdown:hover,
.mp-dropdown:focus {
  background: #f9fafb !important;
  border: 1px solid #e5e7eb !important;
  color: #111 !important;
  font-size: 13px;
  border-radius: 8px;
  padding: 6px 12px;
  box-shadow: none !important;
}

/* TEXT */
.mp-sub {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 6px;
  position: relative;
  z-index: 2;
}

/* COUNT ROW */
.mp-count-row {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 2;
}

.mp-count-row h3 {
  font-size: 30px;
  font-weight: 700;
  margin: 0;
}

/* BADGE */
.mp-badge {
  background: #fee2e2;
  color: #dc2626;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
}

/* FOOTER */
.mp-footer {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

/* AVATARS */
.mp-avatars {
  display: flex;
  align-items: center;
}

.mp-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -10px;
  object-fit: cover;
}

.mp-avatar:first-child {
  margin-left: 0;
}

.mp-avatar.more {
  background: #fff;
  border: 1px solid #ddd;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* PERCENT BOX */
.mp-percent {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 4px 6px 4px 12px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* GREEN BUTTON */
.mp-arrow {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #22c55e;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

/* MOBILE */
@media (max-width: 768px) {

  .mp-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .mp-dropdown {
    width: 100%;
  }

  .mp-count-row h3 {
    font-size: 24px;
  }

  .mp-avatar {
    width: 26px;
    height: 26px;
  }

  .mp-percent {
    font-size: 12px;
  }
}

      `}</style>
    </Card>
  );
}